import { getToolById } from '@/data/tools';
import { type ReactNode } from 'react';

type ToolLayoutProps = {
  toolId: string;
  children: ReactNode;
};

export function ToolLayout({ toolId, children }: ToolLayoutProps) {
  const tool = getToolById(toolId);

  if (!tool) {
    return (
      <div className='space-y-6'>
        <div>
          <h1 className='text-2xl font-bold'>Tool not found</h1>
          <p className='text-muted-foreground mt-1'>The requested tool could not be loaded</p>
        </div>
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-bold'>{tool.name}</h1>
        <p className='text-muted-foreground mt-1'>{tool.description}</p>
      </div>
      {children}
    </div>
  );
}
